<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Bin Name"
                  v-model="bin.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  v-model="bin.binTypeId"
                  :items="binTypeList"
                  color="blue-grey lighten-2"
                  label="Choose BinType..."
                  item-text="typeName"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.bintypeRules"
                ></v-select>
              </v-flex>

              <v-flex sm12>
                <v-text-field
                  name="maxCapacity"
                  label="Max Capacity"
                  v-model="bin.maxCapacity"
                  type="text"
                  :rules="rules.capacityRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="minCapacity"
                  label="Min Capacity"
                  v-model="bin.minCapacity"
                  type="text"
                  :rules="rules.capacityRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="stockBalance"
                  label="Stock Balance"
                  v-model="bin.stockBalance"
                  type="text"
                  :rules="rules.stockBalanceRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="false"
                >
                  <v-text-field
                    slot="activator"
                    label="Self Expire Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selfExpire"
                    readonly
                    :rules="rules.selfExpireRules"
                  ></v-text-field>
                  <v-date-picker v-model="selfExpire"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex sm12 v-if="bin.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="bin.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="bin.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="bin.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="bin.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="bin.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="bin.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm6>
                <v-switch
                  label="Primary Bin"
                  :value="isPrimaryBinFlag"
                  v-model="isPrimaryBinFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="user.roleName === 'PRODUCTION_MANAGER'">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn 
                  color="primary" 
                  :loading="saveLoading" 
                  :disabled="!valid || user.roleName === 'PRODUCTION_MANAGER'" 
                  type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { BinFormRules } from "../../helpers/validation-rules";
import { binService } from "../../services/bin-service";
import { binTypeService } from "../../services/bintype-service";
import { Bin } from "../../models/model";

export default {
  name: "BinDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Bin",
        disabled: false,
        to: "bins"
      },
      {
        text: "Bin Details",
        disabled: true
      }
    ],
    binTypeList: "",
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    statusFlag: true,
    isPrimaryBinFlag: false,
    rules: new BinFormRules(),
    selfExpire: "",
    bin: new Bin(),
    oldBin: new Bin(),
    messageDialogBox: false,
    queryParams: {
      status: "ACTIVE"
    }
  }),
  created() {
    this.getBintypeList();
    const id = this.$route.params.id;
    if (id == "new") {
      // new Customer
    } else {
      this.getBinDetail(id);
    }
  },

  methods: {
    getBintypeList() {
      binTypeService
        .getAllBinType()
        .then(res => {
          this.binTypeList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getBinDetail(id) {
      binService.getBinDetail(id).then(res => {
        this.bin = res.data;
        this.createdDate = commonService.formatDate(
          new Date(this.bin.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.bin.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.selfExpire = commonService.millisecondToDate(
          this.bin.selfExpireInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.oldBin = Object.assign({}, res.data);
        this.statusFlag = this.bin.status == "ACTIVE" ? true : false;
        this.isPrimaryBinFlag = this.bin.isPrimaryBin ? true : false;
      });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.bin.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        this.bin.isPrimaryBin = this.isPrimaryBinFlag ? true : false;
        this.bin.selfExpireInMilliSeconds = commonService.convertToMilliseconds(
          this.selfExpire
        );
        binService
          .saveBin(this.bin)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.bin.id) {
        this.bin = new Bin();
        this.statusFlag = true;
        this.isPrimaryBinFlag = false;
      } else {
        this.bin = Object.assign({}, this.oldBin);
        this.statusFlag = this.bin.status == "ACTIVE" ? true : false;
        this.isPrimaryBinFlag = this.bin.isPrimaryBin ? true : false;
        this.selfExpire = commonService.millisecondToDate(
          this.oldBin.selfExpireInMilliSeconds,
          "YYYY-MM-DD"
        );
      }
    },

    goBack() {
      this.$router.push("/bins");
    }
  }
};
</script>
